// extracted by mini-css-extract-plugin
module.exports = {"sortByMenuItem":"SortByMenuItem_sortByMenuItem__YDq8v","icon":"SortByMenuItem_icon__FWqlK","sortByTitle":"SortByMenuItem_sortByTitle__2oOFQ"};